import { Link } from "@tanstack/react-router"

import { GoBack } from "@/components/shared/layout"
import { Image } from "@/components/ui"

const PaymentPolicyPage = () => {
  return (
    <div className="flex flex-col h-full bg-white">
      {/* Header */}
      <div className="sticky top-0 z-50">
        <GoBack title="Quay về" className="bg-white" />
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4">
        {/* Header */}
        <div className="text-center mb-10 border-b pb-6">
          <h1 className="mx-auto w-[60%] text-2xl sm:text-3xl md:text-4xl font-bold text-primary text-center mb-2 leading-tight">
            CHÍNH SÁCH PHÍ VÀ THANH TOÁN
          </h1>
          <p className="text-gray-500 italic font-medium">
            Chính sách này được cập nhật mới nhất và có hiệu lực từ ngày 25/12/2025.
          </p>
        </div>

        {/* Section A - THÔNG TIN CHÍNH */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase bg-gray-50 p-3 border-l-4 border-primary">
            A - THÔNG TIN CHÍNH
          </h2>

          {/* Table */}
          <div className="overflow-x-auto mb-6">
            <table className="w-full border-collapse text-sm">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="border border-gray-300 p-3 w-12 text-center">STT</th>
                  <th className="border border-gray-300 p-3 w-36 text-left font-semibold">
                    Hạng mục
                  </th>
                  <th className="border border-gray-300 p-3 text-left">Chi tiết</th>
                </tr>
              </thead>
              <tbody>
                <tr className="even:bg-gray-50">
                  <td className="border border-gray-300 p-3 text-center">1</td>
                  <td className="border border-gray-300 p-3 font-semibold">Phí Dịch Vụ</td>
                  <td className="border border-gray-300 p-3">
                    Tùy thuộc vào Dịch Vụ mà Quý Đối Tác thực hiện, được thể hiện cụ thể trên Ứng
                    Dụng tương ứng với từng Dịch Vụ.
                  </td>
                </tr>
                {/* <tr className="even:bg-gray-50">
                  <td className="border border-gray-300 p-3 text-center">2</td>
                  <td className="border border-gray-300 p-3 font-semibold">
                    Thuế, phí, lệ phí liên quan
                  </td>
                  <td className="border border-gray-300 p-3">
                    <ul className="list-disc pl-4 space-y-1">
                      <li>
                        <strong>Đối với cá nhân:</strong> ZZP khấu trừ <strong>10%</strong> thuế thu
                        nhập cá nhân trước khi thanh toán cho Quý Đối Tác, khấu trừ theo từng lần
                        Quý Đối Tác gửi yêu cầu rút tiền.
                      </li>
                      <li>
                        <strong>Đối với pháp nhân:</strong> Phí Dịch Vụ đã bao gồm thuế giá trị gia
                        tăng.
                      </li>
                    </ul>
                  </td>
                </tr> */}
                <tr className="even:bg-gray-50">
                  <td className="border border-gray-300 p-3 text-center">3</td>
                  <td className="border border-gray-300 p-3 font-semibold">Phí nền tảng</td>
                  <td className="border border-gray-300 p-3">
                    <ul className="list-disc pl-4 space-y-1">
                      <li>
                        <span className="font-bold text-red-600">3.000 VND (Ba nghìn đồng)</span>{" "}
                        trên mỗi yêu cầu rút tiền của Quý Đối Tác.
                      </li>
                      <li>Được khấu trừ trực tiếp trong số tiền Quý Đối Tác yêu cầu rút.</li>
                    </ul>
                  </td>
                </tr>
                <tr className="even:bg-gray-50">
                  <td className="border border-gray-300 p-3 text-center">4</td>
                  <td className="border border-gray-300 p-3 font-semibold">Thanh toán</td>
                  <td className="border border-gray-300 p-3">
                    <ul className="list-disc pl-4 space-y-1">
                      <li>
                        Quý Đối Tác có thể gửi yêu cầu rút tiền một lần để rút toàn bộ số dư khả
                        dụng hiện có hoặc rút nhiều lần.
                      </li>
                      <li>
                        Lịch thanh toán định kỳ của ZZP là ngày{" "}
                        <strong>10, 20 và 30 hàng tháng</strong>, nếu ngày thanh toán rơi vào các
                        ngày cuối tuần (Thứ 7, Chủ nhật), lễ, Tết thì yêu cầu rút tiền sẽ được xử lý
                        vào ngày làm việc kế tiếp.
                      </li>
                      <li>
                        Chỉ được thực hiện tối đa <strong>02</strong> yêu cầu rút tiền trong 01 ngày
                        và <strong>10</strong> yêu cầu rút tiền trong 01 tháng.
                      </li>
                      <li>
                        Đối với mỗi yêu cầu rút tiền: Số tiền tối thiểu là{" "}
                        <span className="font-bold text-red-600">
                          50.000 VND (Năm mươi nghìn đồng)
                        </span>{" "}
                        và tối đa là{" "}
                        <span className="font-bold text-red-600">
                          1.000.000 VND (Một triệu đồng)
                        </span>
                        .
                      </li>
                      <li>
                        Tổng số tiền yêu cầu rút trong 01 tháng không quá{" "}
                        <span className="font-bold text-red-600">
                          10.000.000 VND (Mười triệu đồng)
                        </span>
                        .
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Section B - DIỄN GIẢI */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase bg-gray-50 p-3 border-l-4 border-primary">
            B - DIỄN GIẢI
          </h2>

          {/* 1. Các loại phí */}
          <h3 className="font-bold text-gray-800 mt-6 mb-3 border-b border-gray-200 pb-2">
            1. Các loại phí
          </h3>

          {/* 1.1 Phí Dịch Vụ */}
          <h4 className="font-semibold text-gray-700 mt-4 mb-2">1.1 Phí Dịch Vụ:</h4>
          <div className="pl-4 md:pl-6 space-y-3 mb-4 text-gray-700">
            <p>
              (a) Phí Dịch Vụ là khoản thù lao, chi phí Quý Đối Tác được nhận tương ứng với Dịch Vụ
              mà Quý Đối Tác cung cấp cho ZZP. Phí Dịch Vụ đối với mỗi Dịch Vụ sẽ được ZZP thông báo
              công khai trên Ứng Dụng hoặc do Quý Đối Tác đề xuất trên Ứng Dụng trước khi Quý Đối
              Tác xác nhận cung cấp Dịch Vụ cho ZZP và ZZP xác nhận sử dụng Dịch Vụ do Quý Đối Tác
              cung cấp. Phí Dịch Vụ sẽ được thể hiện rõ đã hay chưa bao gồm các khoản thuế, như:
              thuế giá trị gia tăng (GTGT), thuế thu nhập cá nhân (TNCN). Thuế GTGT/ thuế TNCN được
              áp dụng theo mức thuế suất pháp luật quy định tại từng thời điểm.
            </p>
            <p>
              (b) ZZP luôn cố gắng đảm bảo chính xác tất cả các thông tin hiển thị trên Ứng Dụng,
              tuy nhiên, thỉnh thoảng có thể có một số lỗi hoặc thiếu sót do các yếu tố khách quan.
              Nếu phát hiện có sai sót về thông tin Dịch Vụ hiển thị trên Ứng Dụng, hệ thống sẽ tự
              động hủy Dịch Vụ, gửi thông báo cho Quý Đối Tác qua Ứng Dụng. Các chi phí phát sinh từ
              việc hủy Dịch Vụ sẽ được các bên thỏa thuận giải quyết hoặc giải quyết theo hợp đồng
              mà ZZP và Quý Đối Tác đã ký (nếu có).
            </p>
          </div>

          {/* 1.2 Thuế, phí, lệ phí liên quan */}
          <h4 className="font-semibold text-gray-700 mt-4 mb-2">
            1.2 Thuế, phí, lệ phí liên quan:
          </h4>
          <div className="pl-4 md:pl-6 space-y-3 mb-4 text-gray-700">
            <p>
              (a) Các bên hiểu rằng mỗi bên sẽ tự chịu trách nhiệm thực hiện các nghĩa vụ thuế phát
              sinh từ doanh thu, thù lao của mình theo quy định hiện hành về thuế.
            </p>
            <p>
              (b) Đối với trường hợp Quý Đối Tác là cá nhân, ZZP sẽ khấu trừ, kê khai và nộp thuế
              TNCN phát sinh từ Phí Dịch Vụ của Quý Đối Tác trước khi thanh toán cho Quý Đối Tác.
              Mức khấu trừ thuế TNCN là 10% trên Phí Dịch Vụ.
            </p>
            <p>
              (c) Đối với trường hợp Quý Đối Tác là pháp nhân, Phí Dịch Vụ của Quý Đối Tác đã bao
              gồm thuế GTGT theo quy định pháp luật. Quý Đối Tác có nghĩa vụ xuất hóa đơn tài chính
              hợp lệ cho ZZP. Thông tin xuất hóa đơn như sau:
            </p>
            <div className="bg-blue-50 p-4 rounded border border-dashed border-primary">
              <p className="font-bold text-primary">CÔNG TY CỔ PHẦN ALPHA SPACEZ</p>
              <p>Mã số thuế: 0319219773</p>
              <p>
                Địa chỉ: A3.7 &amp; A3.9, Tầng 3, Block A, Tòa Nhà Jamona Height, Số 210 Bùi Văn Ba,
                Phường Tân Thuận, Thành phố Hồ Chí Minh, Việt Nam
              </p>
            </div>
            <p>
              (d) Các khoản thuế có thể thay đổi theo quy định của pháp luật hiện hành, tùy từng
              thời điểm.
            </p>
          </div>

          {/* 1.3 Phí Nền Tảng */}
          <h4 className="font-semibold text-gray-700 mt-4 mb-2">1.3 Phí Nền Tảng:</h4>
          <div className="pl-4 md:pl-6 space-y-3 mb-4 text-gray-700">
            <p>
              (a) Phí Nền Tảng là khoản phí mà Quý Đối Tác phải thanh toán cho ZZP để ZZP xử lý mỗi
              yêu cầu rút tiền Phí Dịch Vụ của Quý Đối Tác.
            </p>
            <p>
              (b) Mức Phí Nền Tảng là <span className="font-bold text-red-600">3.000 VND</span>{" "}
              <em>(Ba nghìn đồng)</em> trên mỗi yêu cầu rút tiền của Quý Đối Tác.
            </p>
            <p>(c) Phí Nền Tảng sẽ không được hoàn lại trong bất cứ trường hợp nào.</p>
            <p>
              (d) ZZP có quyền thay đổi cách tính hoặc biểu phí của Phí Nền Tảng tùy từng thời điểm
              sau khi thông báo trước ngày áp dụng 05 (năm) ngày. Nếu Quý Đối Tác không đồng ý với
              việc ZZP thay đổi cách tính hoặc mức Phí Nền Tảng, Quý Đối Tác có quyền ngừng sử dụng
              Ứng Dụng và thông báo cho ZZP trong vòng 05 (năm) ngày kể từ ngày ZZP thông báo điều
              chỉnh, trong trường hợp này ZZP sẽ phối hợp cùng Quý Đối Tác để xử lý yêu cầu rút tiền
              đối với Phí Dịch Vụ còn lại và Phí Nền Tảng sẽ được áp dụng theo biểu phí trước khi
              thay đổi. Việc Quý Đối Tác tiếp tục sử dụng Ứng Dụng sau 05 (năm) ngày kể từ ngày ZZP
              thông báo điều chỉnh Phí Nền Tảng được hiểu là Quý Đối Tác đồng ý với những thay đổi
              từ ZZP.
            </p>
            <p>
              (e) Quý Đối Tác đồng ý và cho phép ZZP được khấu trừ trực tiếp Phí Nền Tảng trước khi
              chuyển Phí Dịch Vụ cho Quý Đối Tác.
            </p>
          </div>

          {/* 2. Hình thức thanh toán */}
          <h3 className="font-bold text-gray-800 mt-6 mb-3 border-b border-gray-200 pb-2">
            2. Hình thức thanh toán
          </h3>
          <div className="pl-4 md:pl-6 space-y-3 mb-4 text-gray-700">
            <p>
              <strong>2.1</strong> ZZP thanh toán Phí Dịch Vụ cho Quý Đối Tác bằng phương thức
              chuyển khoản theo thông tin tài khoản ngân hàng do Quý Đối Tác cung cấp.
            </p>

            <p>
              <strong>2.2 Mô tả giao dịch thanh toán trên Ứng Dụng:</strong>
            </p>
            <div className="pl-4 space-y-3">
              <p>
                (a) Để làm rõ, Ứng Dụng không phải là một ví điện tử hay cổng thanh toán trung gian,
                không có chức năng như trung gian thanh toán.
              </p>
              <p>
                (b) Để kiểm tra về Phí Dịch Vụ hiện có, cũng như các thông tin liên quan đến thanh
                toán, Quý Đối Tác vào mục &quot;Số dư&quot; trên Ứng Dụng. Tại mục này sẽ hiển thị
                cho Quý Đối Tác đầy đủ thông tin về tổng Phí Dịch Vụ hiện có của Quý Đối Tác, số
                tiền Quý Đối Tác đã thực hiện rút, số tiền hiện còn, thông tin các yêu cầu rút tiền,
                các giao dịch đã xử lý thành công/ đang xử lý/ bị từ chối, phí dịch vụ tương ứng đối
                với mỗi Dịch Vụ, v.v
              </p>
              <p>
                (c) Để ZZP có thể thực hiện thanh toán Phí Dịch Vụ cho Quý Đối Tác, Quý Đối Tác cần
                cung cấp thông tin tài khoản ngân hàng cho ZZP và Quý Đối Tác chịu hoàn toàn trách
                nhiệm đối với thông tin tài khoản ngân hàng do mình cung cấp, ZZP được miễn trừ
                trách nhiệm trong trường hợp Quý Đối Tác cung cấp thông tin tài khoản ngân hàng
                không chính xác, không đầy đủ hoặc cung cấp thông tin tài khoản ngân hàng của một
                bên thứ ba khác không phải là của Quý Đối Tác. Quý Đối Tác thêm thông tin tài khoản
                ngân hàng trên Ứng Dụng như sau:
              </p>
              <ul className="pl-6 space-y-2 border-l-3 border-gray-300">
                <li className="pl-2 border-l-2 border-gray-300">
                  <strong>Bước 1:</strong> Chọn mục &quot;Số dư&quot; trên Ứng Dụng
                </li>
                <li className="pl-2 border-l-2 border-gray-300">
                  <strong>Bước 2:</strong> Chọn &quot;Rút tiền&quot;
                </li>
                <li className="pl-2 border-l-2 border-gray-300">
                  <strong>Bước 3:</strong> Chọn &quot;Thêm tài khoản&quot; và điền/chọn các thông
                  tin theo yêu cầu (gồm tên ngân hàng, số tài khoản và tên chủ tài khoản)
                </li>
                <li className="pl-2 border-l-2 border-gray-300">
                  <strong>Bước 4:</strong> Nhấp &quot;Lưu thông tin tài khoản&quot;
                </li>
                <li className="pl-2 border-l-2 border-gray-300">
                  <strong>Bước 5:</strong> Hệ thống sẽ tự động gửi mã OTP gồm 6 chữ số về số điện
                  thoại (qua SMS hoặc tài khoản Zalo tương ứng với số điện thoại Quý Đối Tác đã đăng
                  ký). Quý Đối Tác nhập mã OTP trên Ứng Dụng, nếu mã OTP chính xác thì hệ thống sẽ
                  tự động chuyển trạng thái lưu thông tin tài khoản ngân hàng của Quý Đối Tác.
                </li>
              </ul>
              <p>
                (d) Quý Đối Tác lưu ý rằng đối với mỗi yêu cầu rút tiền do Quý Đối Tác thực hiện
                trên Ứng Dụng, ZZP sẽ gửi mã OTP (thông qua SMS hoặc Zalo) về số điện thoại mà Quý
                Đối Tác đã cung cấp khi đăng ký tài khoản người dùng trên Ứng Dụng, mã OTP nhằm xác
                minh yêu cầu của Quý Đối Tác.
              </p>
              <p>(e) Hình ảnh mô tả các bước thao tác giao dịch thanh toán trên Ứng Dụng:</p>
              <div className="space-y-4 mt-2">
                <div className="bg-white rounded-lg shadow-lg border overflow-x-auto md:overflow-visible">
                  <Image
                    src="/policy/payment-policy.png"
                    alt="payment_policy"
                    className="h-auto rounded w-[180%] md:w-full"
                  />
                </div>
                <div className="bg-white rounded-lg shadow-lg border overflow-x-auto md:overflow-visible">
                  <Image
                    src="/policy/payment-policy-2.png"
                    alt="payment_policy_2"
                    className="h-auto rounded w-[180%] md:w-full"
                  />
                </div>
              </div>
            </div>

            <p>
              <strong>2.3</strong> Quý Đối Tác đồng ý rằng Quý Đối Tác phải tuân theo thỏa thuận
              người dùng áp dụng cho phương thức thanh toán Quý Đối Tác đã chọn theo chính sách của
              bên thứ ba là các đơn vị cung cấp dịch vụ thanh toán được liên kết trên Ứng Dụng (nếu
              có).
            </p>
          </div>

          {/* 3. Tiến Độ Thanh Toán */}
          <h3 className="font-bold text-gray-800 mt-6 mb-3 border-b border-gray-200 pb-2">
            3. Tiến Độ Thanh Toán
          </h3>
          <div className="pl-4 md:pl-6 space-y-2 mb-4 text-gray-700">
            <p>
              (a) Quý Đối Tác có thể gửi yêu cầu rút tiền một lần để rút toàn bộ số tiền hiện có
              hoặc rút nhiều lần.
            </p>
            <p>
              (b) Lịch thanh toán định kỳ của ZZP là ngày <strong>10, 20 và 30 hàng tháng</strong>.
              Nếu ngày thanh toán rơi vào các ngày lễ, Tết thì yêu cầu rút tiền của Quý Đối Tác sẽ
              được xử lý vào lịch thanh toán kế tiếp.
            </p>
            <p>
              (c) Quý Đối Tác chỉ được thực hiện tối đa <strong>02</strong> yêu cầu rút tiền trong
              01 ngày và <strong>10</strong> yêu cầu rút tiền trong 01 tháng.
            </p>
            <p>
              (d) Số tiền tối thiểu là{" "}
              <span className="font-bold text-red-600">50.000 VND (Năm mươi nghìn đồng)</span> và
              tối đa là{" "}
              <span className="font-bold text-red-600">1.000.000 VND (Một triệu đồng)</span> cho mỗi
              yêu cầu rút tiền.
            </p>
            <p>
              (e) Tổng số tiền yêu cầu rút trong 01 tháng không quá{" "}
              <span className="font-bold text-red-600">10.000.000 đồng (Mười triệu đồng)</span>.
            </p>
            <p>
              (f) ZZP, tùy theo quyết định của mình, có quyền từ chối thanh toán nếu Quý Đối Tác vi
              phạm quy định tại Điều Khoản Sử Dụng hoặc bất cứ chính sách, hợp đồng nào đã được xác
              lập giữa ZZP và Quý Đối Tác.
            </p>
          </div>

          {/* 4. Thanh Toán An Toàn */}
          <h3 className="font-bold text-gray-800 mt-6 mb-3 border-b border-gray-200 pb-2">
            4. Thanh Toán An Toàn
          </h3>
          <div className="pl-4 md:pl-6 space-y-2 mb-4 text-gray-700">
            <p>
              Tất cả thông tin của Quý Đối Tác giao dịch trên Ứng Dụng qua thẻ tín dụng hoặc thẻ
              ngân hàng hoặc các cổng thanh toán trực tuyến, ví điện tử đều được bảo mật thông tin
              bằng mã hóa. Bên cạnh đó, khi thực hiện thanh toán trực tuyến, Quý Đối Tác vui lòng
              lưu ý các chi tiết sau:
            </p>
            <p>
              (a) Chỉ thanh toán trên các website, ứng dụng có chứng chỉ an toàn, bảo mật hệ thống
              thẻ.
            </p>
            <p>
              (b) Tuyệt đối không cho người khác mượn thẻ tín dụng, thẻ ngân hàng của mình để thực
              hiện thanh toán hoặc nhận thanh toán trên Ứng Dụng; trong trường hợp phát sinh giao
              dịch ngoài ý muốn, Quý Đối Tác vui lòng thông báo ngay lập tức để ZZP có thể hỗ trợ
              kịp thời.
            </p>
            <p>
              (c) Kiểm tra thẻ tín dụng, thẻ ngân hàng của mình thường xuyên để đảm bảo tất cả giao
              dịch qua thẻ đều nằm trong tầm kiểm soát của Quý Đối Tác.
            </p>
          </div>

          {/* 5. Thực Hiện Giao Dịch Tại Ứng Dụng */}
          <h3 className="font-bold text-gray-800 mt-6 mb-3 border-b border-gray-200 pb-2">
            5. Thực Hiện Giao Dịch Tại Ứng Dụng
          </h3>
          <div className="pl-4 md:pl-6 space-y-3 mb-4 text-gray-700">
            <p>
              Quy trình giao dịch trên Ứng Dụng của Quý Đối Tác về cơ bản sẽ được thực hiện theo
              trình tự sau:
            </p>

            <div className="space-y-4">
              <div>
                <p>
                  <strong>(a) Bước 1:</strong> Quý Đối Tác tiến hành tạo tài khoản trên Ứng Dụng
                  bằng cách liên kết với tài khoản TikTok (bắt buộc Quý Đối Tác phải có tài khoản
                  TikTok). Cụ thể:
                </p>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>
                    Tại giao diện &quot;Đăng nhập&quot; Quý Đối Tác tích vào ô trống trước nội dung
                    &quot;Tôi xác nhận đã đọc và đồng ý với{" "}
                    <Link to="/terms" className="text-primary underline">
                      điều khoản sử dụng
                    </Link>{" "}
                    và{" "}
                    <Link to="/privacy" className="text-primary underline">
                      chính sách bảo mật
                    </Link>
                    &quot;, sau đó nhấp &quot;Tiếp tục với TikTok&quot;
                  </li>
                  <li>
                    Quý Đối Tác tiếp tục chọn các thông tin được liên kết trên Tài khoản TikTok mà
                    Quý Đối Tác đồng ý chia sẻ cho ZZP, sau đó nhấp chọn &quot;Tiếp tục&quot;. Quý
                    Đối Tác lưu ý rằng bằng việc nhấp &quot;Tiếp tục&quot; Quý Đối Tác được xem là
                    đã đồng ý với &quot;Điều khoản dịch vụ&quot; và &quot;Chính sách quyền riêng
                    tư&quot; của ZZP
                  </li>
                </ul>
              </div>

              <div>
                <p>
                  <strong>(b) Bước 2:</strong> Có 02 loại Dịch Vụ để Quý Đối Tác chọn thực hiện:
                </p>
                <ul className="list-disc pl-6 mt-2 space-y-2">
                  <li>
                    <strong className="px-1">Tham gia quảng bá theo từng chiến dịch</strong> - xem
                    chức năng &quot;Chiến dịch&quot; trên Ứng dụng: Quý Đối Tác theo dõi thông tin
                    các chiến dịch của Nhãn hàng tại mục &quot;Chiến dịch&quot;, để xem thông tin
                    chi tiết của chiến dịch Quý Đối Tác nhấp vào chiến dịch tương ứng. Nếu chiến
                    dịch phù hợp, Quý Đối Tác đủ điều kiện tham gia và Quý Đối Tác muốn tham gia thì
                    nhấp &quot;Đăng ký&quot; và làm theo hướng dẫn trên Ứng Dụng.
                    <p className="mt-2">
                      <span className="px-1">Đối với loại Dịch Vụ này sẽ có 02 hình thức nhỏ:</span>
                    </p>
                    <ul className="list-disc pl-6 mt-1 space-y-1">
                      <li>
                        <strong>Chiến dịch có phí dịch vụ</strong> - được hiển thị ở trường thông
                        tin &quot;Có Cast&quot;: là những chiến dịch sẽ được ZZP thanh toán phí dịch
                        vụ, ngoài ra Quý Đối Tác có thể được nhận hoa hồng từ đường dẫn tiếp thị
                        liên kết (affiliate link) - mức hoa hồng được hiển thị cụ thể trong mỗi
                        chiến dịch (nếu có) và hoa hồng này do nền tảng bán hàng tự phân chia và
                        thanh toán về cho Quý Đối Tác theo chính sách của nền tảng.
                      </li>
                      <li>
                        <strong>Chiến dịch không có phí dịch vụ</strong> - được hiển thị ở trường
                        thông tin &quot;Không Cast&quot;: là những chiến dịch không có phí dịch vụ,
                        Quý Đối Tác sẽ chỉ nhận được sản phẩm mẫu miễn phí để trải nghiệm, ngoài ra
                        Quý Đối Tác có thể được nhận hoa hồng từ đường dẫn tiếp thị liên kết
                        (affiliate link) - mức hoa hồng được hiển thị cụ thể trong mỗi chiến dịch
                        (nếu có) và hoa hồng này do nền tảng bán hàng tự phân chia và thanh toán về
                        cho Quý Đối Tác theo chính sách của nền tảng.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>Tham gia bán hàng bằng cách gắn giỏ hàng:</strong> Quý Đối Tác theo dõi
                    thông tin các sản phẩm tại mục &quot;Sản phẩm&quot;, để xem thông tin chi tiết
                    về sản phẩm và chính sách bán hàng, hoa hồng Quý Đối Tác nhấp vào sản phẩm tương
                    ứng. Nếu chọn tham gia bán sản phẩm, Quý Đối Tác nhấp &quot;Thêm vào trưng
                    bày&quot;, hệ thống sẽ tự động chuyển tiếp đến Tài khoản Tiktok của Quý Đối Tác
                    trên ứng dụng TikTok.
                  </li>
                </ul>
              </div>

              <div>
                <p>
                  <strong>(c) Bước 3:</strong> Quý Đối Tác theo dõi thông tin đăng ký và thực hiện
                  chiến dịch tại mục &quot;Quản lý&quot;, với các mục tương ứng sau:
                </p>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>
                    &quot;Tất cả&quot;: hiển thị toàn bộ các thông tin chiến dịch, sản phẩm mà Quý
                    Đối Tác có giao dịch
                  </li>
                  <li>
                    &quot;Gấp&quot;: hiển thị các nhiệm vụ cần Quý Đối Tác thực hiện ưu tiên vì mức
                    độ gấp rút
                  </li>
                  <li>
                    &quot;Quá hạn&quot;: hiển thị các nhiệm vụ đã hết hạn thực hiện nhưng Quý Đối
                    Tác vẫn chưa hoàn thành
                  </li>
                  <li>
                    &quot;Duyệt - Chờ nhận hàng&quot;: hiển thị các nhiệm vụ mà Quý Đối Tác đã đăng
                    ký và đã được ZZP phê duyệt, đang ở trạng thái gửi hàng mẫu cho Quý Đối Tác để
                    thực hiện nhiệm vụ
                  </li>
                  <li>
                    &quot;Đã hoàn thành&quot;: hiển thị các nhiệm vụ mà Quý Đối Tác đã hoàn thành
                  </li>
                  <li>
                    &quot;Từ chối&quot;: hiển thị các nhiệm vụ mà Quý Đối Tác đã đăng ký nhưng không
                    được ZZP phê duyệt
                  </li>
                </ul>
              </div>

              <p>
                <strong>(d) Bước 4:</strong> Đối với các chiến dịch mà Quý Đối Tác được duyệt tham
                gia, Quý Đối Tác cần tuân thủ việc thực hiện chiến dịch theo yêu cầu và theo thời
                gian được thể hiện ở chi tiết chiến dịch.
              </p>

              <p>
                <strong>(e) Bước 5:</strong> Quý Đối Tác đảm bảo liên tục theo dõi chiến dịch, trao
                đổi, nhận phản hồi, điều chỉnh theo yêu cầu (nếu có) để hoàn thiện Dịch Vụ.
              </p>

              <p>
                <strong>(f) Bước 6:</strong> Sau khi Quý Đối Tác hoàn thành nhiệm vụ, ZZP sẽ tiến
                hành nghiệm thu, các Dịch Vụ được nghiệm thu là hoàn thành sẽ được ZZP ghi nhận Phí
                Dịch Vụ vào &quot;Số dư khả dụng&quot; (nếu có) trong mục &quot;Số dư&quot; trên Ứng
                Dụng. Việc thanh toán Phí Dịch Vụ cho Quý Đối Tác sẽ được thực hiện theo Mục 2 và
                Mục 3 của Chính sách này.
              </p>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="mb-8 p-6 bg-gray-50 border-t border-gray-200 rounded-lg">
          <p className="font-bold text-gray-800 mb-4">
            Mọi thông tin thắc mắc hoặc khiếu nại liên quan đến &quot;Phí và Thanh toán&quot; vui
            lòng liên hệ ZZP theo thông tin sau:
          </p>
          <div className="space-y-1 text-gray-700">
            <p>Bộ phận: Phòng Phát triển kinh doanh</p>
            <p>Email: support@zzp.vn</p>
            <p>Hotline: +84779827236</p>
          </div>
        </section>
      </div>
    </div>
  )
}

export default PaymentPolicyPage
